import { Directive, ElementRef, HostListener, Input } from '@angular/core';


@Directive({
  selector: '[appNoWhiteSpacesAllowed]',
  standalone: false
})
export class NoWhiteSpacesAllowedDirective {

  @Input() public noSpacesAllowed: boolean;

  constructor(private el: ElementRef) {
  }


  @HostListener('input', ['$event']) onInputChange(event) {
    if (this.noSpacesAllowed) {
      const initalValue = this.el.nativeElement.value;
      this.el.nativeElement.value = initalValue.replace(/[^\S]/g, '');
      if (initalValue !== this.el.nativeElement.value) {
        event.stopPropagation();
      }
    }
  }

}
